Jelly.Interface.Show_Toolbar = function(Parameters)
{
	// Open Toolbar	
	Jelly.jQuery("#Jelly_Toolbar").addClass("Visible");
	Jelly.jQuery("#Jelly_Main_Wrapper").addClass("Toolbar_Visible");
	Jelly.jQuery("#Jelly_Inspector").addClass("Toolbar_Visible");
};
